import { useEffect, useRef } from 'react';
import './fire.scss';
import { forwardRef, useImperativeHandle } from 'react';
const FireWork = (props, refs) => {
    const ref = useRef(null);
    const init = (e) => {
        // 获取礼花容器
        const fireworksContainer = ref.current;
        // 颜色数组
        const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffffff', '#ff9900'];

        // 点击创建礼花

        // 移除提示文字

        // 获取点击位置
        const x = e?.clientX || fireworksContainer.offsetLeft + fireworksContainer.offsetWidth / 2;
        const y = e?.clientY || fireworksContainer.offsetTop + fireworksContainer.offsetHeight / 2;

        // 创建礼花粒子数量
        const particleCount = 80;

        // 生成粒子
        for (let i = 0; i < particleCount; i++) {
            // 创建粒子元素
            const particle = document.createElement('div');
            particle.classList.add('firework');

            // 随机角度和距离
            const angle = (i / particleCount) * Math.PI * 2;
            const distance = Math.random() * 150 + 50;

            // 计算粒子偏移量
            const offsetX = Math.cos(angle) * distance;
            const offsetY = Math.sin(angle) * distance;

            // 设置CSS变量
            particle.style.setProperty('--x', `${offsetX}px`);
            particle.style.setProperty('--y', `${offsetY}px`);

            // 随机颜色
            particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];

            // 随机大小
            const size = Math.random() * 6 + 2;
            particle.style.width = `${size}px`;
            particle.style.height = `${size}px`;

            // 设置位置
            particle.style.left = `${x}px`;
            particle.style.top = `${y}px`;

            // 添加到容器
            fireworksContainer.appendChild(particle);

            // 动画结束后移除粒子
            setTimeout(() => {
                particle.remove();
            }, 1500);
        }
    };
    useImperativeHandle(refs, () => ({
        init
    }));
    useEffect(() => {
        init();
    }, []);
    return <div ref={ref} className={['fireworks']}></div>;
};
export default forwardRef(FireWork);
